import { ILlmConversationMessage } from '../../utils/apollo/graphqlSchema';
import { queryTypeConfigLookup } from '../../utils/queryTypeLookup';
import { UnreachableCaseError } from 'ts-essentials';
import React from 'react';
import {
  AssistantResponseWrapper,
  ErrorWraper,
  MessageTextWraper,
  RowWrapper,
  UserPromptWraper,
} from './DebugLlmPageUI';

interface IProps {
  message: ILlmConversationMessage;
}

export const DebugLlmMessage = ({ message }: IProps) => {
  switch (message.__typename) {
    case 'LlmConversationResponseError':
      return (
        <ErrorWraper>
          <RowWrapper>
            [{message.createdAt} (AB: {message.abTestGroup}, took{' '}
            {message.responseTimeMs}ms)] ERROR: {message.message}
          </RowWrapper>
          <MessageTextWraper>DEBUG: {message.debugInfo}</MessageTextWraper>
        </ErrorWraper>
      );
    case 'LlmConversationResponseFormula':
      const queryTypeConf = queryTypeConfigLookup[message.queryType];
      return (
        <AssistantResponseWrapper>
          <MessageTextWraper>
            [{message.createdAt} (AB: {message.abTestGroup}, took{' '}
            {message.responseTimeMs}ms)] ASSISTANT: {message.message}
          </MessageTextWraper>
          <MessageTextWraper>
            {queryTypeConf.display} Query with ID: {message.queryId}. Definition
            Text:
            <pre>{message.queryDefinition}</pre>
          </MessageTextWraper>
          <MessageTextWraper>DEBUG: {message.debugInfo}</MessageTextWraper>
        </AssistantResponseWrapper>
      );
    case 'LlmConversationResponseText':
      return (
        <AssistantResponseWrapper>
          <RowWrapper>
            <MessageTextWraper>
              [{message.createdAt} (AB: {message.abTestGroup}, took{' '}
              {message.responseTimeMs}ms)] ASSISTANT: {message.message}
            </MessageTextWraper>
          </RowWrapper>
          <MessageTextWraper>DEBUG: {message.debugInfo}</MessageTextWraper>
        </AssistantResponseWrapper>
      );
    case 'LlmConversationUserPrompt':
      return (
        <UserPromptWraper>
          <MessageTextWraper>
            [{message.createdAt} (AB: {message.abTestGroup})] USER:{' '}
            {message.message}
          </MessageTextWraper>
        </UserPromptWraper>
      );
    default:
      throw new UnreachableCaseError(message);
  }
};
